import { Row, Col } from 'react-bootstrap'
import { ICustomColumn, IPageProps, IRootState } from 'types'
import { PageHeader, ReturnButton } from 'components'
import { V1ApiReportsClient } from 'core/http-common'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ARBucketDto } from '@v1ReportsApi'
import toast from 'core/toast'
import { DatePicker, DatePickerChangeEvent } from '@progress/kendo-react-dateinputs'
import { Label } from '@progress/kendo-react-labels'
import { Skeleton } from '@progress/kendo-react-indicators'
import SAGrid from 'components/Grid/SAGrid'

const OpenInvoiceBucketsPage = ({ title }: IPageProps) => {

    const [loaded, setLoaded] = useState(false)

    const [endDate, setEndDate] = useState<Date>(new Date())
    const todaysDate: Date = new Date()

    const [buckets, setBuckets] = useState<Array<ARBucketDto>>([])


    const openInvoicesBucketsColumns: ICustomColumn[] = [
        { field: 'id', title: 'ID' },
        { field: 'name', title: 'Name' },
        { field: 'zeroToThirty', title: '0-30', format: '{0:C0}', filterType: 'numeric' },
        { field: 'thirtyOneToSixty', title: '31-60', format: '{0:C0}', filterType: 'numeric' },
        { field: 'sixtyOneToNinety', title: '61-90', format: '{0:C0}', filterType: 'numeric' },
        { field: 'ninetyPlus', title: '90+', format: '{0:C0}', filterType: 'numeric' },
        { field: 'grandTotal', title: 'Grand Total', format: '{0:C0}', filterType: 'numeric' },
    ]

    const handleDateChange = (event: DatePickerChangeEvent) => {

        if (event.value) {
            setEndDate(event.value)
        }
    }
    const fetch = async () => {
        try {
            const result = await V1ApiReportsClient.getARBuckets(endDate)
            setBuckets(result.data)
            setLoaded(true)
        }
        catch (e) {
            toast.responseErrors(e)
        }
    }

    useEffect(() => {
        if (endDate.getFullYear() > 1900)
            fetch()
    }, [endDate])

    return (
        <div id='OpenInvoiceBucketsPage'>
            <PageHeader title={title}>
                <ReturnButton redirectUrl='/reports' />
            </PageHeader>

            <Row>
                <Col>
                    <div className='bg-light border rounded p-3 shadow-sm mb-3'>
                        <form className='k-form' onSubmit={(e) => e.preventDefault()}>
                            <fieldset className='col-md-3'>
                                <Label>End Date:</Label>
                                <DatePicker defaultValue={endDate} value={endDate} max={todaysDate} onChange={handleDateChange} defaultShow={false} />
                            </fieldset>
                        </form>
                    </div>
                    {!loaded ? <Skeleton shape='rectangle' style={{ width: '100%', height: '500px' }} animation={{ type: 'pulse' }} />
                        :
                        <SAGrid
                            features={
                                {
                                    pageable: true,
                                    sortable: true,
                                    filterable: true,
                                    exportToExcel: true,
                                    exportToPDF: false,
                                    reorderColumns: true
                                }
                            }
                            data={buckets}
                            columns={openInvoicesBucketsColumns}
                            defaultSort={[{ field: 'name', dir: 'asc' }]}
                        />
                    }
                </Col>
            </Row>
        </div>
    )
}
export default OpenInvoiceBucketsPage
